export const MenuItems = [
  {
    title: "Home",
    url: "/",
    CName: "nav-links",
    icon: "fa-solid fa-house-user",
  },
  {
    title: "About Us",
    url: "/about",
    CName: "nav-links",
    icon: "fa-solid fa-circle-info",
  },
  {
    title: "Contact Us",
    url: "/contact",
    CName: "nav-links",
    icon: "fa-solid fa-address-book",
  },
  {
    title: "Activity",
    url: "/activity",
    CName: "nav-links",
    icon: "fa-solid fa-calendar-days",
    ddIcon: "fas fa-caret-down",
  },
];
export const MenuItems1 = [
  {
    title: "Multimedia",
    url: "/gallery",
    CName: "nav-links",
    icon: "fa-sharp fa-solid fa-image",
    ddIcon: "fas fa-caret-down",
  },
];

export const EventDropDownMenu = [
  {
    id: 1,
    title: "Ongoing",
    url: "/ongoing",
    CName: "dropdown-links",
  },
  {
    id: 2,
    title: "Upcoming",
    url: "/upcoming",
    CName: "dropdown-links",
  },
];

export const EventDropDownMenu1 = [
  {
    id: 1,
    title: "Gallery",
    url: "/gallery",
    CName: "dropdown-links",
  },
  {
    id: 2,
    title: "Video",
    url: "/video",
    CName: "dropdown-links",
  },
];
